export const PAYSTACK_EMAIL = "galapagous09@gmail.com"